export const TIMESHEETS_CAN_ENTER_TIMESHEETS = 1
export const TIMESHEETS_CAN_VIEW_OTHER_STAFF_TIMESHEETS = 2
export const CAN_VIEW_PROJECTS = 3
export const CAN_CREATE_PROJECTS = 4
export const CAN_EDIT_PROJECTS = 5
export const CAN_VIEW_USERS = 6
export const CAN_CREATE_USERS = 7
export const CAN_EDIT_USERS = 8
export const CAN_VIEW_USER_ROLES = 9
export const CAN_CREATE_USER_ROLES = 10
export const CAN_EDIT_USER_ROLES = 11
//export const PROJECTS_CAN_EDIT_USER_ROLES = 12
export const CAN_VIEW_CLIENTS = 13
export const CAN_CREATE_CLIENTS = 14
export const CAN_EDIT_CLIENTS = 15
export const CAN_VIEW_CLIENT_TYPES = 16
export const CAN_CREATE_CLIENT_TYPES = 17
export const CAN_EDIT_CLIENT_TYPES = 18
export const CAN_VIEW_PROJECT_ACTIVITIES = 19
export const CAN_CREATE_PROJECT_ACTIVITIES = 20
export const CAN_EDIT_PROJECT_ACTIVITIES = 21
export const CAN_VIEW_PROJECT_DISCIPLINES = 22
export const CAN_CREATE_PROJECT_DISCIPLINES = 23
export const CAN_EDIT_PROJECT_DISCIPLINES = 24
export const CAN_VIEW_PROJECT_STATUSES = 25
export const CAN_CREATE_PROJECT_STATUSES = 26
export const CAN_EDIT_PROJECT_STATUSES = 27
export const CAN_VIEW_PROJECT_FEE_TYPES = 28
export const CAN_CREATE_PROJECT_FEE_TYPES = 29
export const CAN_EDIT_PROJECT_FEE_TYPES = 30
export const CAN_VIEW_PROJECT_FEE_RATES = 31
export const CAN_CREATE_PROJECT_FEE_RATES = 32
export const CAN_EDIT_PROJECT_FEE_RATES = 33
export const CAN_VIEW_PROJECT_LAND_USES = 34
export const CAN_CREATE_PROJECT_LAND_USES = 35
export const CAN_EDIT_PROJECT_LAND_USES = 36
export const MISC_CAN_VIEW_ADDRESS_TYPES = 37
export const MISC_CAN_CREATE_ADDRESS_TYPES = 38
export const MISC_CAN_EDIT_ADDRESS_TYPES = 39
export const MISC_CAN_VIEW_CONTACT_MEDIUMS = 40
export const MISC_CAN_CREATE_CONTACT_MEDIUMS = 41
export const MISC_CAN_EDIT_CONTACT_MEDIUMS = 42
export const REPORTS_CAN_VIEW_FEE_DRAWDOWN = 43
export const USER_PERMISSIONS_CAN_CHANGE_USER_PERMISSIONS = 44
export const USER_PERMISSIONS_CAN_CHANGE_USER_ROLE_PERMISSIONS = 45
export const REPORTS_PROJECT_BUDGET_REPORT = 46
export const TIMESHEETS_CAN_VIEW_UNBILLABLE_TYPES = 47
export const TIMESHEETS_CAN_CREATE_UNBILLABLE_TYPES = 48
export const TIMESHEETS_CAN_EDIT_UNBILLABLE_TYPES = 49
export const REPORTS_CAN_VIEW_PROJECTS = 50
export const PROJECTS_CAN_VIEW_EDIT_PROJECT_DETAILS = 51
export const PROJECTS_CAN_VIEW_EDIT_PROJECT_CLIENTS = 52
export const PROJECTS_CAN_VIEW_EDIT_PROJECT_LOCATIONS = 53
export const PROJECTS_CAN_VIEW_EDIT_PROJECT_BUDGETS = 54
export const PROJECTS_CAN_VIEW_EDIT_PROJECT_FEE_RATES = 55
export const PROJECTS_CAN_VIEW_EDIT_PROJECT_NOTES = 56
export const REPORTS_INVOICING = 57
export const PROJECTS_CAN_VIEW_WRITE_OFFS = 58
export const PROJECTS_CAN_CREATE_WRITE_OFFS = 59
export const PROJECTS_CAN_EDIT_WRITE_OFFS = 60
export const PROJECTS_CAN_REMOVE_WRITE_OFFS = 61
export const PROJECTS_CAN_VIEW_INVOICES = 62
export const PROJECTS_CAN_DOWNLOAD_INVOICES = 63
export const PROJECTS_CAN_REMOVE_INVOICES = 64
export const PROJECTS_CAN_CREATE_INVOICES = 65
export const PROJECTS_CAN_EDIT_INVOICES = 66
export const PROJECTS_CAN_VIEW_SUPPLIER_BUDGETS = 67
export const PROJECTS_CAN_CREATE_SUPPLIER_BUDGETS = 68
export const PROJECTS_CAN_EDIT_SUPPLIER_BUDGETS = 69
export const PROJECTS_CAN_DOWNLOAD_SUPPLIER_BUDGET_FILE = 70
export const PROJECTS_CAN_REMOVE_SUPPLIER_BUDGETS = 71
export const PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY = 72
export const CLIENT_PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY = 73
export const EXPENSES_CAN_VIEW_OTHER_USERS_EXPENSES = 74

export const MISC_CAN_VIEW_PROJECT_EXPENSE_TYPES = 75
export const MISC_CAN_CREATE_PROJECT_EXPENSE_TYPES = 76
export const MISC_CAN_EDIT_PROJECT_EXPENSE_TYPES = 77
export const NOTIFICATIONS_CAN_CREATE_NOTIFICATIONS = 78
export const NOTIFICATIONS_CAN_EDIT_NOTIFICATIONS = 79
export const NOTIFICATIONS_CAN_REMOVE_NOTIFICATIONS = 80

export const ANNUAL_LEAVE_CAN_REQUEST_LEAVE_FOR_OTHER_USERS = 86

export const checkPermission = (permission) => {
    const user = JSON.parse(sessionStorage.getItem('user'))

    console.log('permissiosn', user)

    if(user && user.user && user.user.simple_permissions && user.user.simple_permissions.length){
        return user.user.simple_permissions.includes(permission)
    }

    return false
}